import React, { FunctionComponent } from "react";
import { Switch, Route, withRouter, RouteComponentProps } from "react-router";
import { CreditCustomer } from "./CreditCustomerDetails/CreditCustomer";
import { CreditCustomerReferenceList } from "./CreditCustomerDetails/CreditCustomersTable/CreditCustomerReferenceList";


const CreditCustomerManagementRoutes: FunctionComponent<RouteComponentProps> = ({
    match: { url }
  }) => (
    <Switch>
      <Route exact path={`${url}/`} render={() => <CreditCustomer />} />
      <Route exact path={`${url}/:id` } component={CreditCustomerReferenceList} />
      </Switch>
      );

export const CreditCustomerManagement = withRouter(CreditCustomerManagementRoutes);